import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function RecruitmentCountryList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasreccounAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment country");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasreccounEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment country");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }
  
  const columns = [
    { field: "RC_Id", label: "#" },
    { field: "RC_CountryName", label: "Recruitment Country" },
    { field: "RC_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasreccounEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RC_Id));

        navigate(
          `/RecruitmentCountryLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/RecruitmentCountry/list`}
      actions={actions}
      title={`Recruitment Country`}
      {...(hasreccounAddprivilege(privilegeData) && {
        linkvalue: `/RecruitmentCountryLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default RecruitmentCountryList;
